import axios from 'axios'
import KeycloakService from '../utils/keycloakService'
import { endpoint } from '../features/ProRithm/Constants'
import {
  DEVICE_VITALS_GET,
  DEVICE_VITALS_POST,
  GET_DEVICE_RING,
  GET_DEVICE_RING_VITALS,
  GET_SLEEP_DATA,
} from '../utils/Endpoints'

export const getDevices = async () => {
  const token = KeycloakService.getToken()
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${endpoint?.getAllDevices}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    // console.error('Error opening file: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}

export const setVitalRanges = async (vitalRanges: any) => {
  const token = KeycloakService.getToken()
  try {
    const response: any = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${DEVICE_VITALS_POST}`,
      vitalRanges,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    // console.error('Error creating user: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}

export const getVitalRanges = async (encounterId: string) => {
  const token = KeycloakService.getToken()
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${DEVICE_VITALS_GET}${encounterId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    // console.error('Error opening file: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}

export const getRingVitals = async (muhId: string) => {
  const token = KeycloakService.getToken()
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_DEVICE_RING_VITALS}${muhId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )

    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    // console.error('Error opening file: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}

export const getVitalTracking = async (
  muhId: string,
  vital: string,
  version: string,
  startDate: string,
  endDate: string,
  type: string
) => {
  const token = KeycloakService.getToken()
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_DEVICE_RING}${muhId}/${version}/${vital}?startDateString=${startDate}&endDateString=${endDate}&type=${type}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )

    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    // console.error('Error opening file: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}

export const getSleepData = async (sleepProps: string[]) => {
  const token = KeycloakService.getToken()
  try {
    const response: any = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_SLEEP_DATA}`,
      sleepProps,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    // console.error('Error creating user: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}

export const getSleepTracking = async (
  muhId: string,
  date: string,
  vital: string,
  version: string
) => {
  const token = KeycloakService.getToken()
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_DEVICE_RING}${muhId}/date/${date}/${version}/${vital}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )

    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    // console.error('Error opening file: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}

export const getSleepTrackingWeekMonth = async (
  muhId: string,
  startDate: string,
  endDate: string
) => {
  const token = KeycloakService.getToken()
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_DEVICE_RING}metric-summary?patientId=${muhId}&startDate=${startDate}&endDate=${endDate}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )

    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}
